import { Component, computed, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { Constants } from "../../../constants/constants";
import { TableSelectedRow, UserGroupModelType } from "../../../models";
import { SystemLayoutService } from "../../../services";
import { DataTableComponent } from "../../table/data-table/data-table";

@Component({
  selector: "adaa-user-groups-modal",
  imports: [TranslatePipe, DataTableComponent],
  templateUrl: "./user-groups-modal.html",
  styleUrl: "./user-groups-modal.scss",
})
export class UserGroupsModalComponent {
  private _systemLayoutService = inject(SystemLayoutService);
  modal: NgbActiveModal = inject(NgbActiveModal);
  readonly Constants = Constants;

  @Input() selectedGroups: UserGroupModelType[];
  @Input() idProp: string;

  paramsStringGroups = computed(() => `enitiyId=${this._systemLayoutService.entity?.id}`);
  rowSelected: TableSelectedRow;

  public save(): void {
    this.modal.close(this.rowSelected?.allSelectedRows);
  }
}
